import React, { useState } from "react";
import { pdf } from "@react-pdf/renderer";
import { MdPictureAsPdf } from "react-icons/md";
import { ProjectTask } from "../../../../interfaces/ProjectTask";
import GanttPdf from "./GanttPdf";

interface Line {
  date: string;
  plannedHours: number;
}

interface Props {
  tasks: ProjectTask[];
  schedules?: Record<number, Line[]>;
  employeesCapacity?: Record<number, number>;
  title?: string;
  showProject?: boolean;
  modoCliente?: boolean;
  fileName?: string;
  className?: string;
}

/** Botão "Exportar PDF" do cronograma — gera o documento sob clique e dispara o download. */
const GanttPdfButton: React.FC<Props> = ({
  tasks,
  schedules,
  employeesCapacity,
  title = "Cronograma",
  showProject,
  modoCliente,
  fileName = "cronograma.pdf",
  className,
}) => {
  const [busy, setBusy] = useState(false);

  const handleExport = async () => {
    setBusy(true);
    try {
      const blob = await pdf(
        <GanttPdf
          tasks={tasks}
          schedules={schedules}
          employeesCapacity={employeesCapacity}
          title={title}
          showProject={showProject}
          modoCliente={modoCliente}
        />
      ).toBlob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error("Erro ao exportar cronograma em PDF", e);
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleExport}
      disabled={busy}
      className={
        className ??
        "flex items-center justify-center gap-1.5 rounded-xl border border-gray-200 px-5 py-2.5 text-sm font-semibold text-gray-700 transition-all hover:bg-gray-50 active:scale-[.98] disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-600 dark:text-gray-200 dark:hover:bg-navy-700"
      }
    >
      <MdPictureAsPdf className="h-4 w-4" aria-hidden="true" /> {busy ? "Gerando PDF…" : "Exportar PDF"}
    </button>
  );
};

export default GanttPdfButton;
